<template>
  <div class="auth" :style="{ minHeight: height }">
    <div class="header">
      <div>
        <!--<a :href="junziqanIndex">-->
        <!--<img src="/images/logo.png"/>-->
        <!--</a>-->
        <p>
          <a :href="junziqanIndex" class="jzq-com">返回首页</a>
          <!--<span @click="logout">退出登录</span>-->
        </p>
      </div>
    </div>
    <el-card class="card" :body-style="bodyStyle">
      <div class="guide">
        <img class="authLogo" src="/images/auth/authLogo.png" />
        <div class="text">
          <p class="title">
            企业实名认证
          </p>
          <p class="content">
            《中华人民共和国电子签名法》要求签署方身<br />
            份真实，请根据您的身份选择以下操作方式
          </p>
        </div>
        <div style="text-align: center;">
          <el-checkbox :checked="true" v-model="checked">
            <span style="color: #666666">我已阅读并同意</span>
            <a
              class="showAgreement"
              style="color: #409EFF"
              href="javascript:void(0)"
              @click="showProtocol = true"
              >《实名认证服务协议》</a
            >
          </el-checkbox>
        </div>
        <el-row class="btn-wrapper">
          <el-button
            @click="showAuth()"
            class="btn"
            type="danger"
            :disabled="!checked"
          >
            法定代表人操作
          </el-button>
          <el-button
            @click="showAuth(4)"
            class="btn plain"
            plain
            :disabled="!checked"
          >
            不是法定代表人操作
          </el-button>
        </el-row>
      </div>
    </el-card>
    <real-name-protocol
      :visible.sync="showProtocol"
      type="register"
    ></real-name-protocol>
  </div>
</template>

<script>
import { logout } from "@/assets/js/http-serve/http-methods";
import GlobalConfig from "@/assets/js/config/global";
import RealNameProtocol from "@/components/protocol/RealName";

export default {
  components: { RealNameProtocol },
  name: "index",
  layout: "user",
  data() {
    return {
      height: "100%",
      authPath: "/auth/entIdentityAuth",
      logout: logout,
      junziqanIndex: GlobalConfig.domain.junziqianWebOp + "/viewIndex",
      bodyStyle: {
        position: "relative",
        top: "50%",
        transform: "translateY(-50%)"
      },
      checked: true,
      showProtocol: false
    };
  },
  methods: {
    showAuth(type) {
      this.$router.push({
        path: this.authPath,
        query: { defaultAuthenticationType: type || 1 }
      });
    }
  },
  created() {
    this.$nextTick(() => {
      this.height =
        (document.body.clientHeight || window.document.body.clientHeight) +
        "px";
    });
    //没有登录用户的信息，则返回登录页
    /*if(!this.$store.getters.hasAuthUser){
        this.$router.push({path: '/login'});
        return;
      }*/
    //已实名认证，则回到首页
    /*if(authUser.identityAuth === 1){
        this.$router.push({path: '/'});
        return;
      }*/
  }
};
</script>

<style lang="less" scoped>
.auth {
  width: 100%;
  min-height: 100%;
  position: relative;
  .header {
    margin-top: 15px;

    div {
      height: 58px;
      line-height: 58px;
      max-width: 1200px;
      margin: 0 auto;
      p {
        float: right;
        font-weight: bold;
        color: #a0a0a0;
        span {
          cursor: pointer;
        }

        .jzq-com {
          color: #a0a0a0;
          display: inline-block;
          /*border-right: 1px solid #aaa;*/
          padding-right: 10px;
          margin-right: 10px;
          height: 16px;
          line-height: 16px;
        }
      }
    }
  }
  .card {
    width: 440px;
    height: 330px;
    box-sizing: border-box;
    padding-top: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -165px;
    margin-left: -220px;
    background: rgba(255, 255, 255, 1);
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    border: none;

    .guide {
      .authLogo {
        display: block;
        margin: auto;
        width: 138px;
      }

      .text {
        text-align: center;

        .title {
          height: 22px;
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;
          color: rgba(0, 0, 0, 1);
        }

        .content {
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          color: rgba(0, 0, 0, 0.45);
          padding-top: 10px;
        }
      }

      .btn-wrapper {
        margin-top: 28px;
        text-align: center;

        .btn {
          width: 150px;
          height: 25px;
          opacity: 1;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 400;
          line-height: 0;
          color: rgba(255, 255, 255, 1);

          &.plain {
            border: 1px solid rgba(236, 28, 28, 1);
            color: rgba(236, 28, 28, 1);

            &:hover {
              color: rgba(242, 96, 96, 1);
              border: 1px solid rgba(242, 96, 96, 1);
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/auth/authGuide_copy.vue